import assetsBase from '@exodus/assets-base'
import { PAYMENT_METHOD_TYPES } from '../constants.js'
import { createPaymentMethod } from '../payment-method.js'

const assets = assetsBase.default || assetsBase

export const ENABLED_ASSETS = {
  __proto__: null,
  algo_algorand: assets.algorand?.name,
  ada_cardano: assets.cardano?.name,
  avax_avalanche: assets.avalanchec?.name,
  btc_bitcoin: assets.bitcoin?.name,
  dot_polkadot: assets.polkadot?.name,
  eth_ethereum: assets.ethereum?.name,
  ftm_fantom: assets.fantommainnet?.name,
  ltc_litecoin: assets.litecoin?.name,
  mana_ethereum: assets.decentraland?.name,
  pol_polygon: assets.matic?.name,
  pol_ethereum: assets.polygon?.name,
  sol_solana: assets.solana?.name,
  usdt_ethereum: assets.tetherusd?.name,
  usdc_ethereum: assets.usdcoin?.name,
  usdc_polygon: assets.usdc_matic_0a883d9b?.name,
  usdc_solana: assets.usdcoin_solana?.name,
  xrp_ripple: assets.ripple?.name,
}

export const PAYMENT_METHOD_NAMES = {
  __proto__: null,
  ach: 'ach',
  bank: 'bank',
  card: 'card',
  debit: 'debit',
  international_debit: 'international_debit',
  international_credit: 'international_credit',
  us_debit: 'us_debit',
  us_credit: 'us_credit',
}

export const ACH_PAYMENT_METHOD = createPaymentMethod({
  id: PAYMENT_METHOD_NAMES.ach,
  type: PAYMENT_METHOD_TYPES.bank,
  countries: [{ id: 'US', enabled: true }],
})

export const INTERNATIONAL_DEBIT_PAYMENT_METHOD = createPaymentMethod({
  id: PAYMENT_METHOD_NAMES.international_debit,
  type: PAYMENT_METHOD_TYPES.card,
  currencies: [{ id: 'USD', enabled: false }],
})

export const US_DEBIT_PAYMENT_METHOD = createPaymentMethod({
  id: PAYMENT_METHOD_NAMES.us_debit,
  type: PAYMENT_METHOD_TYPES.card,
  currencies: [{ id: 'USD', enabled: true }],
})

export const PAYMENT_METHODS = new Map([
  [PAYMENT_METHOD_NAMES.ach, [ACH_PAYMENT_METHOD]],
  [PAYMENT_METHOD_NAMES.debit, [INTERNATIONAL_DEBIT_PAYMENT_METHOD, US_DEBIT_PAYMENT_METHOD]],
])

export const ORDER_STATUSES = {
  __proto__: null,
  complete: 'Complete',
  declined: 'Declined',
  draft: 'Draft',
  expired: 'Expired',
  processed: 'Processed',
  user_custody: 'UserCustody',
}

export const EXODUS_ORDER_STATUSES = {
  __proto__: null,
  complete: [ORDER_STATUSES.complete],
  failed: [ORDER_STATUSES.declined, ORDER_STATUSES.expired],
  'in-progress': [ORDER_STATUSES.draft, ORDER_STATUSES.user_custody, ORDER_STATUSES.processed],
}

export const DEFAULT_FIAT_PRECISION = 2
export const DEFAULT_CRYPTO_PRECISION = 4
